import {
    ApiResponse,
    BackendClient,
    BackendClientParameters,
} from "@internal/backstage-plugin-utility-common";

export type PolicyCenterClientOptions = Omit<
    BackendClientParameters,
    "targetPluginId"
>;

export class PolicyCenterClient extends BackendClient {
    constructor(options: PolicyCenterClientOptions) {
        super({
            discoveryApi: options.discoveryApi,
            identityApi: options.identityApi,
            targetPluginId: "policy-center",
        });
    }

    /**
     * Checks if the current user has active policies.
     * @returns ApiResponse with a boolean indicating policy status.
     */
    async fetchHasActivePolicies(): Promise<ApiResponse<boolean>> {
        return this.api("has-active-policy", {
            method: "GET",
        });
    }
}
